import { IAuthenticatedUserInfo } from '@notes/webintegrations-common'
import { Store } from 'redux'
import { LayoutSDKWrapper } from './layoutSDK/LayoutSDKWrapper'
import { setDetailVisibility } from './redux/actions/detailView'
import { IState } from './redux/state'
import { Constants } from './shared/Constants'

export function createHubLayoutSDKWrapper(store: Store<IState>, userInfo?: IAuthenticatedUserInfo, isEdgeHub?: boolean): LayoutSDKWrapper {
  const hostApp = isEdgeHub ? Constants.HOST_APP_TYPES.EDGE_HUB : Constants.HOST_APP_TYPES.WEB_APP

  return new LayoutSDKWrapper({
    userInfo,
    onDetailViewChanged: (isVisible: boolean) => store.dispatch(setDetailVisibility(isVisible)),
    hostApp,
    disableMediaDownload: false,
    isFeedEnabled: true,
    isEdgeHub: !!isEdgeHub,
    enableOneNotePages: !!isEdgeHub,
  })
}
